import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { startRealtimeMonitor } from "./lib/realtimeMonitor";

// Suppress opaque cross-origin "Script error." entries that have no
// stack/file info — they originate from third-party scripts and are not
// actionable. Real app errors (with file/stack) still propagate.
window.addEventListener("error", (event) => {
  if (
    event.message === "Script error." &&
    !event.filename &&
    !event.error
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

startRealtimeMonitor();

createRoot(document.getElementById("root")!).render(<App />);
